export default __webpack_public_path__ + "static/media/kao_arrendadora.c5b17f61.jpg";